<template>
  <div class="autorisation">
    <v-app id="inspire">
      <v-app id="inspire">
        <v-main>
          <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12">
                  <v-toolbar color="#2196F3" dark flat>
                    <v-toolbar-title
                        class="d-flex justify-space-between align-center"
                        style="width: 100%"
                    >
                      <span>{{ $t("authorisation.title") }}</span>
                      <v-select
                          :items="langs"
                          v-model="currentLang"
                          item-value="key"
                          item-text="label"
                          class="mt-2 select--lang"
                          style="max-width: 50px"
                      >
                        <template slot="selection" slot-scope="{ item }">
                          <span>{{ item.key }}</span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <span>{{ item.key }}</span>
                        </template>
                      </v-select>
                    </v-toolbar-title>
                    <v-spacer/>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="valid" ref="authorisation" @submit.prevent="sendForm">
                      <v-text-field
                          :label="$t('authorisation.login')"
                          name="login"
                          prepend-icon="mdi-account"
                          type="text"
                          v-model="login"
                          :rules="loginRules"
                          required
                      />
                      <v-text-field
                          id="password"
                          :label="$t('authorisation.password')"
                          name="password"
                          prepend-icon="mdi-lock"
                          type="password"
                          v-model="password"
                          :rules="passwordRules"
                          required
                      />
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            type="submit"
                            class="sumbit_btn"
                            :class="{ disabled: disableSend === true }"
                            dark
                            color="#2196F3"
                        >{{ $t("authorisation.apply") }}
                        </v-btn
                        >
                      </v-card-actions>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
      </v-app>
    </v-app>
  </div>
</template>

<script>
// @ is an alias to /src
import toastr from "toastr";

export default {
  name: "Autorisation",
  data: () => ({
    valid: false,
    login: "",
    password: "",
    currentLang: "az",
    langs: [
      {
        key: "ru",
        label: "Русский",
      },
      {
        key: "en",
        label: "English",
      },
      {
        key: "az",
        label: "Azərbaycan",
      },
    ],
    loginRules: [
      (v) => !!v || "Введите логин",
      (v) => v.length <= 15 || "Name must be less than 10 characters",
    ],
    passwordRules: [(v) => !!v || "Введите пароль"],
    drawer: null,
    disableSend: false,
  }),
  props: {
    source: String,
  },
  mounted() {
    this.$store.commit("stopLoader");
    this.currentLang = this.$store.state.lang = this.$i18n.locale;
    localStorage.setItem("lang", this.$i18n.locale);
    if (localStorage.hash) {
      this.$router.push("/");
    }
  },
  watch: {
    /**
     * apply chosen language
     * */
    currentLang: function () {
      this.$vuetify.lang.current = this.$i18n.locale = this.currentLang;
      localStorage.setItem("lang", this.$i18n.locale);
    },
  },
  methods: {
    sendForm() {
      if (this.$refs.authorisation.validate()) {
        this.$store.commit("startLoader");
        const request = {login: this.login, password: this.password};
        this.$axios
            .post("http://core.memo.az/account/login", request)
            .then((res) => {
              if (res.data.status == "fail") {
                localStorage.removeItem("hash");
                toastr.warning("Введеный логин или пароль не верен");
                return;
              }
              localStorage.hash = res.data.hash;
              this.$router.push("/");
            })
            .finally(() => {
              this.$store.commit("stopLoader");
            });
      }
    },
  },
};
</script>
<style lang="scss">
.autorisation i:before {
  color: #2196f3;
}

.autorisation .v-input {
  font-weight: 600;
}

.autorisation .v-text-field input {
  font-weight: 300;
  color: #757575;
}

.autorisation .v-select__selections {
  text-transform: uppercase;
}
</style>